import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./css/Home.css";
import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; 
import CookieBanner from "./CookieBanner";


const Home = () => {
  const settings = {
    dots: true, // Muestra puntos de navegación
    infinite: true, // Ciclo infinito
    speed: 500, // Velocidad de transición
    slidesToShow: 1, // Número de slides a mostrar
    slidesToScroll: 1, // Número de slides que se mueven
    autoplay: true, // Habilita autoplay
    autoplaySpeed: 5000, // Velocidad de autoplay (3 segundos)
    
  };


const logos = [
  './img/c++.jpg',
  './img/java.jpg',
  './img/python.jpg',
  './img/node.jpg',
  './img/bootstrap.png',
  './img/css.png',
  './img/html.jpg',
  './img/postgresql.jpg',
];

  return (
    <div className="container_header">
    <div className="carousel-container">
      <Slider {...settings}>
        <div className="carousel-slide">
          <img src="./img/slide-5.jpg" alt="Slide 1" className="carousel-image" />
          <div className="carousel-caption">
            <h2>Cloud</h2>
          </div>
        </div>
        <div className="carousel-slide">
          <img src="./img/slide-4.jpg" alt="Slide 2" className="carousel-image" />
          <div className="carousel-caption">
            <h2>Local Server</h2>
          </div>
        </div>
        <div className="carousel-slide">
          <img src="./img/slide-6.jpg" alt="Slide 2" className="carousel-image" />
          <div className="carousel-caption">
            <h2>Desarrollos</h2>
          </div>
        </div>
      </Slider>
    </div>
    <div className="centrado">
    <CookieBanner />
    <div className="col-12 col-md-12 contenedor_global">
  <div className="row contenedor_fila flex-column flex-md-row">
    {/* Primer Contenedor */}
    <div className="box col-10 col-md-6 d-flex centrar_texto">
      <div className="titulo_grande">
        ¡Bienvenidos!
      </div>
      <div className="titulo">
        ¡Bienvenido a la Revolución Tecnológica para tu Empresa!
      </div>
      <div className="texto">
        Nos alegra que estés aquí para explorar cómo podemos ayudarte a desplegar tus servidores de forma segura y eficiente, ya sea en la nube o en tu infraestructura local. Nuestro equipo está comprometido en brindarte soluciones personalizadas que maximicen el rendimiento, escalabilidad y seguridad de tus sistemas. Sin importar el tamaño de tu proyecto, estamos listos para acompañarte en cada paso, asegurando que tu negocio aproveche al máximo la tecnología disponible. ¡Descubre cómo podemos optimizar tus operaciones y llevar tu infraestructura al siguiente nivel!
      </div>
    </div>

    {/* Segundo Contenedor */}
    <div className="box col-10 col-md-6 d-flex centrar_texto2 bg-blue">
      <blockquote className="quote text-center">
        "Lo que hace la nueva tecnología es crear nuevas oportunidades para hacer un trabajo que los clientes quieren que se haga."
      </blockquote>
      <div className="autor">
        Tim O'Reilly, <a href="https://www.oreilly.com/tim/bio.html" class="link">oreilly.com</a>
      </div>
    </div>
  </div>
<div className="salto"></div>
<div className="row contenedor_fila flex-column flex-md-row">
    {/* Primer Contenedor */}
    <div className="box col-10 col-md-6 centrar_texto2 bg-blue">
      <blockquote className="quote text-center">
        "La nube no es un lugar, es una forma de hacer TI (Tecnologías de la Información)."
      </blockquote>
      <div className="autor">
        Michael Dell, <a href="https://www.dell.com/en-us/dt/corporate/about-us/leadership/michael-dell.htm" class="link">dell.com</a>
      </div>
    </div>
    <div className="box col-10 col-md-6 centrar_texto">
      <div className="titulo_grande">
        Cloud
      </div>
      <div className="titulo">
      Potenciando la Innovación con AWS
      </div>
      <div className="texto">
      El despliegue en la nube se refiere al proceso de configurar y administrar recursos informáticos a través de servicios en la nube, lo que permite a las organizaciones ejecutar aplicaciones y almacenar datos de manera flexible y escalable. Con el uso de plataformas como Amazon Web Services (AWS), las empresas pueden beneficiarse de una infraestructura robusta, optimizar costos y mejorar la agilidad en el desarrollo de aplicaciones. AWS proporciona una amplia gama de servicios que permiten a las organizaciones innovar rápidamente y adaptarse a las demandas cambiantes del mercado.
      </div>
    </div>    
  </div>
  <div className="salto"></div>

<div className="logos-container">
      {logos.map((logo, index) => (
        <div key={index} className="logo-item">
          <img src={logo} alt={`Logo ${index + 1}`} className="logo-img" />
        </div>
      ))}
    </div>
    <div className="salto"></div>
    </div>
    </div>
</div> 
 );
};

export default Home;